<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="payHeaders" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table
            :headers="payHeaders"
            :items="payOrders"
            :options.sync="pagination"
            :server-items-length="totalPayOrders"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{item.Username}}</td>
                <td class="text-end">{{ item.PackageNumber | currency}}</td>
                <td class="text-end">{{ item.TotalWeight | currency}}</td>
                <td class="text-end font-weight-bold">{{item.TotalAmount | currency}}</td>
                <td class="text-end pay-button">
                  <v-btn text icon color="orange lighten-2" @click="openPayDetail(item.ID)">
                    <v-icon>attach_money</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-dialog v-model="dialogPayDetail" persistent max-width="850px">
            <v-card>
              <v-card-title>
                <span class="title">Thanh toán đơn hàng</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md pa-0>
                  <v-layout row wrap>
                    <v-flex lg12>
                      <div>Mã khách hàng: {{payOrderDetail.CustomerID}}</div>
                    </v-flex>
                    <v-flex lg12>
                      <div>Tên khách hàng: {{payOrderDetail.CustomerName}}</div>
                    </v-flex>
                    <v-flex lg12>
                       <v-text-field :disabled="customerServiceRole" v-model="payOrderDetail.PhoneNumber" label="Điện thoại" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg12 class="font-weight-bold">
                      <div>Số lô thanh toán: {{selected.length | currency}}</div>
                    </v-flex>
                    <v-flex lg12>
                      <v-data-table
                        :headers="orderHeader"
                        :items="payOrderDetail.packages"
                        :mobile-breakpoint="100"
                        :items-per-page="100"
                        :hide-default-footer="true"
                        item-key="ID"
                        show-select
                        v-model="selected"
                      >
                        <template v-slot:item="{ item, isSelected, select }">
                          <tr :active="isSelected" @click="select(!isSelected)">
                            <td>
                              <v-checkbox primary hide-details :input-value="isSelected"></v-checkbox>
                            </td>
                            <td>
                              <a target="blank" href="/quan-ly-bao-hang">{{item.PackageCode}}</a>
                            </td>
                            <td class="text-end">{{ item.Volume | currency }}</td>
                            <td class="text-end">{{ item.Weight | currency('', 1)}}</td>
                            <td class="text-end">{{ item.FeeUnit | currency}}</td>
                            <td class="text-end">{{ item.FeeShipVND | currency}}</td>
                            <td class="text-end">{{ item.Amount | currency}}</td>
                          </tr>
                        </template>
                        <template v-slot:body.append>
                          <tr>
                            <td colspan="2" class="font-weight-bold">Tổng</td>
                            <td class="text-end font-weight-bold">{{totalVolume| currency }}</td>
                            <td class="text-end font-weight-bold">{{totalWeight| currency('', 1)}}</td>
                            <td class="text-end font-weight-bold"></td>
                            <td class="text-end font-weight-bold">{{totalFeeShip | currency}}</td>
                            <td class="text-end font-weight-bold">{{totalAmount | currency}}</td>
                          </tr>
                          <tr>
                            <td colspan="6" class="font-weight-bold">Phí khác</td>
                            <td class="text-end font-weight-bold">
                              <h-currency-input
                                :disabled="customerServiceRole"
                                class="fee-cn-footer"
                                v-model="otherFee"
                                :decimal="0"
                              ></h-currency-input>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="orange darken-1" text @click="dialogPayDetail = false">Hủy</v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="savePayOrder"
                  v-if="!customerServiceRole"
                  :disabled="selected.length == 0"
                >Thanh toán</v-btn>
                <v-btn absolute top right class="mt-5" @click="printPayOrder">
                  <v-icon color="orange darken-2" class="mr-2">print</v-icon>In đơn
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="loading" fullscreen>
            <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
              <v-layout justify-center align-center>
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-layout>
            </v-container>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
    <div class="pt-5">
      <h3>Lịch sử thanh toán</h3>
    </div>
    <payment-history class="px-0"></payment-history>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";
import { currency } from "@/commons/currency";
import { sendErrorNotice } from "@/commons/utils";
import PaymentHistoryList from "@/views/PaymentHistory/PaymentHistoryList.vue";
export default {
  components: {
    "hpo-filter": Filtering,
    "payment-history": PaymentHistoryList
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      timeout: 2000,
      payMode: false,
      search: "",
      otherFee: 0,
      payHeaders: [
        {
          text: "Mã khách hàng",
          value: "Username",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Tổng lô",
          value: "PackageNumber",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng cân",
          value: "TotalWeight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng tiền",
          value: "TotalAmount",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "",
          align: "end",
          filterable: false,
        }
      ],
      orderHeader: [
        {
          text: "Mã lô",
          value: "PackageCode",
          right: false
        },
        {
          text: "Số kiện",
          value: "Volume",
          align: "end"
        },
        {
          text: "Cân/khối",
          value: "Weight",
          align: "end"
        },
        {
          text: "Đơn giá",
          value: "FeeUnit",
          align: "end"
        },
        {
          text: "Phí ship",
          value: "FeeShipVND",
          align: "end"
        },
        {
          text: "Thành tiền",
          value: "Amount",
          align: "end"
        }
      ],
      selected: [],
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "payorder_list",      
      filterConditions: [],
      quickFilterConditions: [],
      dialogPayDetail: false
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    },
    dialogPayDetail() {
      this.selected = [];
    },
    payOrderDetail() {
      if (this.payOrderDetail && this.payOrderDetail.Orders) {
        this.selected = this.payOrderDetail.Orders.slice();
      }
    }
  },
  computed: {
    ...mapState("payOrder", {
      payOrders: "all",
      totalPayOrders: "total",
      payOrderDetail: "selectedItem",
      loading: "loading",
    }),
    pages() {
      if (this.options.rowsPerPage == null || this.options.totalItems == null)
        return 0;

      return Math.ceil(this.options.totalItems / this.options.rowsPerPage);
    },
    totalVolume() {
      return _.sumBy(this.selected, "Volume");
    },
    totalWeight() {
      return _.sumBy(this.selected, "Weight");
    },
    totalFeeShip() {
      return _.sumBy(this.selected, "FeeShipVND");
    },
    totalAmount() {
      return _.sumBy(this.selected, "Amount");
    },    
    customerServiceRole() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.CustomerService;
    },
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("payOrder/getPayOrderList", param);
    },
    toggleAll() {
      if (this.selected.length === this.payOrderDetail.Orders.length)
        this.selected = [];
      else this.selected = this.payOrderDetail.Orders.slice();
    },
    openPayDetail(customerId) {
      this.$store.dispatch("payOrder/getPayOrderDetail", customerId);
      this.dialogPayDetail = true;
    },
    savePayOrder() {
      if (this.selected.length == 0) {
        sendErrorNotice("Hãy chọn hóa đơn cần thanh toán");
        return;
      }
      this.$store.dispatch("payOrder/updatePayOrder", {
        package_ids: _.map(this.selected, "ID"),
        otherFee: this.otherFee,
        uid: this.payOrderDetail.ID,
        param: {pagination: configs.PAGINATION}
      });
      this.dialogPayDetail = false;
      setTimeout(this.filter_data, 300);
    },
    printPayOrder() {
      var mywindow = window.open("", "PRINT");

      mywindow.document.write(`<html><head><title></title>

<style>
.row {
    display: flex;
}

.flex {
    flex: 1 1 auto;
}

.flex.lg6 {
    flex-basis: 50%;
    flex-grow: 0;
    max-width: 50%;
}

.flex.lg8 {
    flex-basis: 66%;
    flex-grow: 0;
    max-width: 66%;
}

.flex.lg4 {
    flex-basis: 34%;
    flex-grow: 0;
    max-width: 34%;
}

.flex.lg3 {
    flex-basis: 25%;
    flex-grow: 0;
    max-width: 25%;
}

.flex.lg12 {
    flex-basis: 100%;
    flex-grow: 0;
    max-width: 100%;
}

.title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
}

.sub-title {
    font-size: 16px;
    font-weight: bold;
}

.l-text {
    text-align: left;
}

.r-text {
    text-align: right;
}

.note-text {
    font-size: 14px;
    font-weight: bold;
    font-style: italic;
    text-align: center;
}

.body-text {
    font-size: 14px;
}

table {
    border-collapse: collapse;
    width: 100%;
}

td,
th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
}

hr {
    border: 0.5px solid #dddddd;
}

tr,
td,
th {
    page-break-inside: avoid !important;
}

@media print {
    @page {
        size: auto;
        margin: 10mm 15mm 10mm 15mm;
    }

    html {
        background-color: #FFFFFF;
        margin: 0px;
    }

    body {
        margin: 0mm 0mm 0mm 0mm;
    }
}
</style></head><body style='width:210mm'>`);

      mywindow.document.write(`<div class='layout wrap'>
            <div class='flex lg12'><p class='title'>Hóa đơn thanh toán</p></div>
            <div class='row'><div class='flex lg8'></div><div class='flex lg4'><p class='body-text r-text'>Ngày in đơn: 21-08-2019</p></div></div>
            <div class='flex lg12'><hr></div>
            <div class='row'><div class='flex lg12'><p class='body-text l-text'>Khách hàng: ${this.payOrderDetail.CustomerName}</p></div></div>
            <div class='row'><div class='flex lg12'><p class='body-text l-text'>Điện thoại: ${this.payOrderDetail.PhoneNumber}</p></div></div>
            <div class='row'><div class='flex lg12'><p class='body-text l-text'>Số đơn thanh toán: ${this.selected.length}</p></div></div>`);
      mywindow.document.write(`<table>
            <tr> <th>Mã lô</th> <th class='body-text r-text'>Số kiện</th> <th class='body-text r-text'>Cân/khối</th> <th class='body-text r-text'>Đơn giá</th> <th class='body-text r-text'>Phí ship</th><th class='body-text r-text'>Thành tiền</th></tr>`);
      for (let i = 0; i < this.selected.length; i++) {
        const element = this.selected[i];
        mywindow.document.write(
          `<tr> <td>${element.PackageCode}</td> <td class='body-text r-text'>${currency(
            element.Volume
          )}</td><td class='body-text r-text'>${currency(
            element.Weight
          )}</td> <td class='body-text r-text'>${currency(
            element.FeeUnit
          )}</td> <td class='body-text r-text'>${currency(
            element.FeeShipVND
          )}</td> <td class='body-text r-text'>${currency(
            element.Amount
          )}</td></tr>`
        );
      }
      mywindow.document
        .write(`<tr> <td class='sub-title'>Tổng</td> <td class='sub-title r-text'>${currency(
        this.totalVolume
      )}</td><td class='sub-title r-text'>${currency(
        this.totalWeight
      )}</td> <td class='sub-title r-text'></td> 
        <td class='sub-title r-text'>${currency(
        this.totalFeeShip
      )}</td> <td class='sub-title r-text'>${currency(
        this.totalAmount
      )}</td></tr>
            <tr> <td class='body-text' colspan='5'>Phí khác</td><td class='body-text r-text'>${currency(
              this.otherFee
            )}</td></tr>
            </table>
            <div class='flex lg12'><p class='note-text'>https://happyorder.vn</p></div>
            </div>
            </body></html>`);
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/
      mywindow.print();
      mywindow.close();
      return true;
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    }
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>

<style>
.pay-button {
  width: 135px;
}

.fee-cn-footer .v-text-field .v-label--active {
  right: 0px !important;
  left: auto !important;
}

.fee-cn-footer .v-text-field__slot input {
  text-align: right !important;
  font-size: 0.9em !important;
}
</style>
